module.exports = __webpack_public_path__ + "img/5-ilpakamanioMASY_thumb.d2f65fb0.jpg";